import { observer } from "mobx-react-lite"
import { IEventCollectionItem } from "../../interfaces"
import { formatDate } from "../../utils"
import { Image, Text } from "../."

interface UpcomingEventCardProps {
	event: IEventCollectionItem
}

export const UpcomingEventCard = observer(({ event }: UpcomingEventCardProps) => {
	return (
		<div className="mb-[10px]">
			<Image url={event.heroImage} width={300} height={300} />

			<div className={`mt-[16px] flex flex-col`}>
				<Text variant="large-bold" style="ml-[16px] mb-[8px]">
					{event.name}
				</Text>
				<Text style="ml-[16px]">{`${formatDate(event.start)}${event.location ? `, ${event?.location?.name}` : ""}`}</Text>
			</div>
		</div>
	)
})
